import KeyAccountLayout from "@/layouts/KeyAccountLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const keyAccountProductRoutes: RouteRecordRaw[] = [
  {
    path: "/key-account-products",
    name: "keyAccountProducts",
    component: () =>
      import("@/views/restricted/key-account-products/KeyAccountProductListView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "keyAccountProducts",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_PRODUCT_READ_PERMISSION"],
    },
  },
  {
    path: "/key-account-products/:keyAccountProductId",
    name: "keyAccountProductDetail",
    component: () =>
      import("@/views/restricted/key-account-products/KeyAccountProductDetailView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "keyAccountProducts",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_PRODUCT_READ_PERMISSION"],
    },
  },
  {
    path: "/key-account-products/request-drafts/create",
    name: "keyAccountProductRequestDraftCreate",
    component: () =>
      import("@/views/restricted/key-account-products/KeyAccountProductRequestDraftCreateView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "keyAccountProducts",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_PRODUCT_CREATE_REQUEST_PERMISSION"],
    },
  },
  {
    path: "/key-account-products/request-drafts/:requestDraftId/edit",
    name: "keyAccountProductRequestDraftUpdate",
    component: () =>
      import("@/views/restricted/key-account-products/KeyAccountProductRequestDraftCreateView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "keyAccountProducts",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_PRODUCT_CREATE_REQUEST_PERMISSION"],
    },
  },
  {
    path: "/key-account-products/request-drafts/:requestDraftId",
    name: "keyAccountProductRequestDraftDetail",
    component: () =>
      import("@/views/restricted/key-account-products/KeyAccountProductRequestDraftDetailView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "keyAccountProducts",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_PRODUCT_READ_PERMISSION"],
    },
  },
];

export default keyAccountProductRoutes;
